module.exports = __webpack_public_path__ + "static/media/btc.f545247b.svg";